<template>
  <br />
  <van-cell-group title="" inset>
    <van-field
      left-icon="wap-home"
      v-model="userInfo.hospitalName"
      label="管理机构"
      readonl
    >
    </van-field>
    <van-field
      left-icon="certificate"
       v-model="proValue"
      label="项目名称"
      readonly
    />
    <van-field
      left-icon="setting-o"
      v-model="techFor"
      label="技术支持"
      readonly
    />
  </van-cell-group>
  <van-divider
    :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }"
    >此评估大概需要1分钟，共9道题，已完成：{{ question.userResInfoVo.pointCount }}</van-divider
  >
  <van-form @submit="onSubmit">
    <van-space direction="vertical" size="2rem" fill>
      <van-row>
        <van-col offset="0.5" span="24">
          <van-cell-group inset>
            <van-notice-bar
              :theme-vars="themeVars"
              wrapable
              :scrollable="false"
            >
              第 {{ question.userResInfoVo.point }} 题：{{
                question.userResInfoVo.queDec
              }}
            </van-notice-bar>
            <br />
            <van-cell v-if="showSYN">
              <van-radio-group v-model="question.userResInfoVo.ansCode">
                <van-radio name="1" icon-size="24px">是</van-radio>
                <br />
                <van-radio name="0" icon-size="24px">否</van-radio>
              </van-radio-group>
            </van-cell>
            <van-cell v-if="showSGEN">
              <van-radio-group v-model="question.userResInfoVo.ansCode">
                <van-radio name="1" icon-size="24px">男</van-radio>
                <br />
                <van-radio name="2" icon-size="24px">女</van-radio>
              </van-radio-group>
            </van-cell>
            <van-cell v-if="showSAB">
              <van-radio-group v-model="question.userResInfoVo.ansCode">
                <van-radio name="1" icon-size="24px">A</van-radio>
                <br />
                <van-radio name="0" icon-size="24px">B</van-radio>
              </van-radio-group>
            </van-cell>
            <van-cell v-if="showINPUT">
              <van-field
                v-model="question.userResInfoVo.tiZhong"
                label="体重"
                placeholder="体重，单位公斤,请填写[数字]"
                :rules="[{ required: true, pattern, message: '请填写准确数字，如:85。默认单位公斤，不用填写' }]"
              />
              <br />
              <van-field
                v-model="question.userResInfoVo.shenGao"
                label="身高"
                placeholder="身高，单位厘米,请填写[数字]"
                :rules="[{ required: true, pattern, message: '请填写准确数字，如：175。默认单位厘米，不用填写' }]"
              />
            </van-cell>
          </van-cell-group>
        </van-col>
      </van-row>

      <van-row gutter="20">
        <van-col span="3"></van-col>
        <van-col offset="4" span="8">
          <van-button
            round
            block
            color="linear-gradient(to right, #f67f34, #d55809)"
            native-type="submit"
            @click="getQuePre"
          >
            上一题
          </van-button></van-col
        >
        <van-col span="8">
          <van-button
            round
            block
            color="linear-gradient(to right, #f67f34, #d55809)"
            native-type="submit"
            @click="getQueSave"
          >
            {{ bMessage }}
          </van-button></van-col
        >
      </van-row>
    </van-space>
  </van-form>
  <br />
  <van-cell-group inset v-if="showEnd">
    <van-field
      v-model="sms"
      center
      clearable
      left-icon="shield-o"
      error
      label="检前评估进度"
      placeholder="已完成"
      readonly
    >
      <template #button>
        <van-button
          size="small"
          color="linear-gradient(to top, #ff0844 0%, #ffb199 100%)"
          @click="getUserLogin"
          >查询</van-button
        >
      </template>
    </van-field>
  </van-cell-group>
  <br/>
  <br/>
  <br/>
</template>
<script>
import { ref, toRefs, reactive, onMounted } from "vue";
import { getUserInfo } from "../../api/userinfo";
import { postUserResInfo, getQueInit, postUserResPre } from "../../api/queInfo";
import { showNotify } from "vant";
import { showConfirmDialog } from "vant";
import { useRouter } from "vue-router";
import { postUserLog } from "../../api/userlog";
import { getCheckBinding } from '../../api/permission'
import { showDialog } from "vant";
export default {
  setup() {
    const router = useRouter();
    const ulog = reactive({
      UserLog: {
        path: "",
      },
    });
    const show = ref(false);
    const checked = ref("");
    const showSYN = ref(false);
    const showSGEN = ref(false);
    const showSAB = ref(false);
    const showINPUT = ref(false);
    const pointEnd = ref(false);
    const showEnd = ref(false);
    const bMessage = ref("");
    const proValue = ref("心血管疾病风险分析");
    const techFor = ref("中科软科技");
     // 校验函数可以返回 Promise，实现异步校验
    const pattern = /^(0|[1-9][0-9]*)$/;
    const state = reactive({
      userInfo: {
        hospitalName: "",
        area: "",
        realName: "",
        phone: "",
        age: "",
        gender: "",
      },
    });

    const question = reactive({
      userResInfoVo: {
        pointCount: "",
        queCode: "",
        queType: "",
        queDes: "",
        point: "",
        ansCode: "",
        tiZhong: "",
        shenGao: "",
      },
    });

    const themeVars = reactive({
      fontSizeMd: 32,
    });

    const getQueSave = () => {
      console.log(question.userResInfoVo.ansCode);
      postUserResInfo(question.userResInfoVo).then((res) => {
        console.log(res.data.code);
        if (res.data.code == 0) {
          if (question.userResInfoVo.point == 9) {
              /*showConfirmDialog({
                message: "您已经完成检查前的风险评估数据体检。\n",
              })
              .then(() => {
                //router.push("/personAction");
                location.reload();
              })
              .catch(() => {});*/
                 /**登陆验证 */
              getCheckBinding().then((res1) => {
                console.log("登陆验证"+res1.data.code);
                const binding = res1.data.code;
                if (binding == 60000) {
                    router.push({
                         path: 'bindingHospLogin',
                         query: {callBackUrl:'basicAnalyse'}
                       });
                } else if (binding == 40000) {
                    showDialog({
                        title: "错误提醒",
                        message: "【登陆异常】：请您在微信端打开",
                        theme: "round-button",
                    }).then(() => {
            
                    }); 
                } else {
                  showConfirmDialog({
                        message: "您已经完成体检外数据补充。\n",
                  })
                  .then(() => {
                      location.reload();
                  })
                  .catch(() => {});
                }
            })
          } else {
            showNotify({ type: "success", message: "提交成功" });
            location.reload();
          }
        } else {
          console.log("绑定失败，失败原因:" + res.data.message);
          showNotify({ type: "danger", message: "提交失败，请稍后重试" });
        }
      });
    };

    const getQuePre = () => {
      ulog.UserLog.path = router.currentRoute.value.fullPath;
      console.log("当前页面路径==" + ulog.UserLog.path);
      postUserLog(ulog.UserLog).then(() => {});
      postUserResPre(question.userResInfoVo).then((res) => {
        console.log(res.data.data);
        question.userResInfoVo = res.data.data;
        if (question.userResInfoVo.queType == "S_YN") {
          showSYN.value = true;
          showSGEN.value = false;
          showSAB.value = false;
          showINPUT.value = false;
        } else if (question.userResInfoVo.queType == "S_AB") {
          showSAB.value = true;
          showSYN.value = false;
          showSGEN.value = false;
          showINPUT.value = false;
        } else if (question.userResInfoVo.queType == "S_GEN") {
          showSGEN.value = true;
          showSAB.value = false;
          showSYN.value = false;
          showINPUT.value = false;
        } else if (question.userResInfoVo.queType == "INPUT") {
          showINPUT.value = true;
          showSYN.value = false;
          showSGEN.value = false;
          showSAB.value = false;
        } else {
          console.log(question.userResInfoVo.queCode);
        }
      });
    };
    //判定是否绑定完成，没有需要登陆并绑定一下
    const getUserLogin = () => {
      /**登陆验证 */
          getCheckBinding().then((res1) => {
                console.log("登陆验证"+res1.data.code);
                const binding = res1.data.code;
                if (binding == 60000) {
                    router.push({
                         path: 'bindingHospLogin',
                         query: {callBackUrl:'basicAnalyse'}
                       });
                } else if (binding == 40000) {
                    showDialog({
                        title: "错误提醒",
                        message: "【登陆异常】：请您在微信端打开",
                        theme: "round-button",
                    }).then(() => {
            
                    }); 
                } else {
                    router.push('basicAnalyse');
                }
            })
    }
    onMounted(() => {
      getUserInfo().then((res1) => {
        state.userInfo = res1.data.data;
        console.log(res1.data.data);
      });
      
      getQueInit().then((res) => {
        question.userResInfoVo = res.data.data;
        if (question.userResInfoVo.queType == "S_YN") {
          showSYN.value = true;
        } else if (question.userResInfoVo.queType == "S_AB") {
          showSAB.value = true;
        } else if (question.userResInfoVo.queType == "S_GEN") {
          showSGEN.value = true;
        } else if (question.userResInfoVo.queType == "INPUT") {
          showINPUT.value = true;
        } else {
          console.log(question.userResInfoVo.queCode);
        }
        if (question.userResInfoVo.point == 9) {
          bMessage.value = "提交完成";
          if (question.userResInfoVo.ansCode != null) {
            showEnd.value = true;
          }
        } else {
          bMessage.value = "下一题";
        }

        console.log(question.userResInfoVo);
      });
    });
    return {
      ref,
      show,
      showSYN,
      showSGEN,
      showSAB,
      showINPUT,
      checked,
      themeVars,
      question,
      bMessage,
      pointEnd,
      showEnd,
      proValue,
      techFor,
      pattern,
      getQueSave,
      getUserLogin,
      getQuePre,
      ...toRefs(state),
    };
  },
};
</script>
